export const apiBaseUri = process.env.REACT_APP_LEARNER_API_BASE_URL || "";
export const serverName = process.env.REACT_APP_SERVER_NAME || "";
export const cscConnectApiBaseUri =
  process.env.REACT_APP_CSC_CONNECT_API_BASE_URL || "";
export const cscConnectCallbackUriBcbf =
  process.env.REACT_APP_CSC_CONNECT_CLIENT_CALLBACK_URI_BCBF || "";
export const cscConnectCallbackUriDra =
  process.env.REACT_APP_CSC_CONNECT_CLIENT_CALLBACK_URI || "";

export const cscConnectClientIdDra =
  process.env.REACT_APP_CSC_CONNECT_CLIENT_ID || "";
export const cscConnectClientIdBcbf =
  process.env.REACT_APP_CSC_CONNECT_CLIENT_ID_BCBF || "";

export const p2ePortalUrl = "https://cscpassporttoearning.myp2e.org/#/";
export const resourcesUrl =
  "https://drive.google.com/drive/folders/1vTYjNWvRTYSG5aAFg_GafWuFZsN83Tj5?usp=sharing";
export const aadhaarGatewayUrl =
  process.env.REACT_APP_AADHAAR_GATEWAY_URL || "";
export const aadhaarGatewayClientId =
  process.env.REACT_APP_AADHAAR_GATEWAY_CLIENT_ID || "";

export type CourseType =
  | "dra-graduate"
  | "dra-undergraduate"
  | "bcbf-advance"
  | "bcbf-basic";
export const courseDraMap: Record<CourseType, string> = {
  "dra-graduate": process.env.REACT_APP_COURSE_DRA_GRADUATE || "",
  "dra-undergraduate": process.env.REACT_APP_COURSE_DRA_UNDER_GRADUATE || "",
  "bcbf-advance": process.env.REACT_APP_ST_BC_ADVANCE_COURSE_ID || "",
  "bcbf-basic": process.env.REACT_APP_ST_BC_BASIC_COURSE_ID || "",
};
export const webappBaseUrl = process.env.REACT_APP_WEBAPP_BASE_URL || "";
export const projectStartDate = "2024-12-01T00:00:00";

export const draCourseIds = [
  process.env.REACT_APP_ST_DRA_GRADUATE_COURSE_ID,
  process.env.REACT_APP_ST_DRA_UNDER_GRADUATE_COURSE_ID,
];

export const bcbfCourseIds = [
  process.env.REACT_APP_ST_BC_ADVANCE_COURSE_ID,
  process.env.REACT_APP_ST_BC_BASIC_COURSE_ID,
];

export const onboardingPortalBaseURL =
  process.env.REACT_APP_ONBOARDING_PORTAL_BASE_URL || "";

export const onboardingPortalBaseURLBCBF =
  process.env.REACT_APP_ONBOARDING_PORTAL_BASE_URL_BCBF || "";
